import { ALERT_PAYMENT_STATUS, ALERT_PAYMENT_MODE, ALERT_PAYMENT_MODE_VALUE, MORE_PAYMENT_ALERT_MESSAGE, ONE_PAYMENT_ALERT_MESSAGE } from "constants/alert";
import { PAYMENT_MODES } from "../../constants/paymentModes";

/**
 * This is the old function, do not use it ,instead use src/shared/logics/src/utils/getPaymentAlert.ts  function
 * TO DO -- Will remove after sometime
 */

interface IpaymentAlertInfo{
  mode: string,
  bankName: [string],
  message: string
}

export const getPaymentAlert = (paymentAlertInfo: IpaymentAlertInfo, mode : string = "", name: string = "") => {
  if (mode) {
      const upiAlert = (paymentAlertInfo as any)[mode];
      if (upiAlert) {
        let alertClass = "";
        let alertMessage = "";
        let isPaymentEnabled = true;
        let isPaymentMethodVisible = true;
        const { bankName, message } = upiAlert;

        if (mode == ALERT_PAYMENT_MODE.UPI) { // incase of upi coming in payment alert and bankName is empty/ BHIM UPI is missing
          if (Array.isArray(bankName)) {
            if (!bankName.includes(ALERT_PAYMENT_MODE_VALUE.UPI)) {
              bankName.push(ALERT_PAYMENT_MODE_VALUE.UPI);
            }
          }
        }

        if (upiAlert.status === ALERT_PAYMENT_STATUS.DISABLE) {
          alertClass = "disable-payment-mode";
          if (message) {
            alertMessage = message.replace("<value>", name);
          }
          isPaymentEnabled = false;
        } else if (upiAlert.status === ALERT_PAYMENT_STATUS.NORMAL) {
          if (message) {
            if (Array.isArray(bankName) && bankName.length && bankName.includes(name)) {
              alertMessage = message.replace("<value>", name);
            }
          }
        } else if (upiAlert.status === ALERT_PAYMENT_STATUS.WARNING) {
          alertClass = "warn-payment-mode";
          if (message) {
            if (Array.isArray(bankName) && bankName.length && bankName.includes(name)) {
              alertMessage = message.replace("<value>", name);
            }
          }
        } else if (upiAlert.status === ALERT_PAYMENT_STATUS.HIDE) {
          alertClass = "hide-payment-mode";
          isPaymentEnabled = false;
          isPaymentMethodVisible = false;
        }

        return {
          alertClass,
          alertMessage,
          isPaymentEnabled,
          isPaymentMethodVisible,
        };
      }
  }

  return {
    alertClass: "",
    alertMessage: "",
    isPaymentEnabled: true,
    isPaymentMethodVisible: true,
  };
};

  /**
   * @param {Object} paymentAlertInfo is a hashmap contains payment alert data mapped with payment methods
   * @description this method returns alert message in case payment alert status is 3 (hide)
   */
export const getPaymentMethodDisabledMessage = (paymentAlertInfo: {mode: string, bankName: [string], message: string}) => {
  if (paymentAlertInfo) {
    const paymentMethods = Object.keys(paymentAlertInfo);
    const paymentMethodLength = paymentMethods.length;
    if (paymentMethodLength) {
      let message = "";
      let disabledMethodCount = 0;
      paymentMethods.forEach((value, index) => {
        let paymentMode = null;
        const { status } = (paymentAlertInfo as any)[value];
        if (value === ALERT_PAYMENT_MODE.UPI && status === ALERT_PAYMENT_STATUS.HIDE) {
          paymentMode = ALERT_PAYMENT_MODE_VALUE.UPI + " UPI";
        } else if (value === ALERT_PAYMENT_MODE.MOBILE_WALLETS && status === ALERT_PAYMENT_STATUS.HIDE) {
          paymentMode = ALERT_PAYMENT_MODE_VALUE.MOBILE_WALLETS;
        } else if (value === ALERT_PAYMENT_MODE.NET_BANKING && status === ALERT_PAYMENT_STATUS.HIDE) {
          paymentMode = ALERT_PAYMENT_MODE_VALUE.NET_BANKING;
        } else if (value === ALERT_PAYMENT_MODE.CC_DC && status === ALERT_PAYMENT_STATUS.HIDE) {
          paymentMode = ALERT_PAYMENT_MODE_VALUE.CC_DC;
        }

        if (paymentMode) {
          if (disabledMethodCount === 0) {
            message = paymentMode;
          } else if (index === paymentMethodLength - 1) {
            message = `${message} and ${paymentMode}`;
          } else {
            message = `${message}, ${paymentMode}`;
          }
          disabledMethodCount += 1;
        }
      });

      if (message) {
        if (disabledMethodCount >= 2) {
          return message + MORE_PAYMENT_ALERT_MESSAGE;
        }
        return message + ONE_PAYMENT_ALERT_MESSAGE;
      }
    }
  }

  return null;
};

/**
 * @description -- function to filter the upilist on which
 *  alerting does not exists
 */
 export const getUpiIntentListForFailure = (
  paymentAlertInfo: { mode: string; bankName: [string]; message: string },
  mode: string = "",
  upiIntentList: any[]
) => {
  try {
    if (mode == PAYMENT_MODES.UPI) {
      const alert = paymentAlertInfo?.mode;
      const bankName = alert?.bankName;
      // there will be no intent visible if UPI is disabled
      if (alert?.status == ALERT_PAYMENT_STATUS.DISABLE || alert?.status == ALERT_PAYMENT_STATUS.HIDE || alert?.status == ALERT_PAYMENT_STATUS.WARNING) {
        return [];
      }
      // Filter out only those PSP's on which altering does not exist (i.e Not in bankName array)
      if (
        Array.isArray(bankName) &&
        bankName.length > 0) {
        upiIntentList?.forEach((listItem: any, index: number) => {
          bankName?.forEach((name: string) => {
            if (name?.toLowerCase() === listItem.title?.toLowerCase()) {
              upiIntentList.splice(index, 1);
            }
          });
        });
        return upiIntentList;
      }
      // if ALL UPI method are having alerting the upi_intent will not be there in fallback modes
      return upiIntentList;
    }
  } catch (error) {
    console.log("Error in getUpiIntentListForFailure", error);
  }
};
